// extracted by mini-css-extract-plugin
module.exports = {"ToggleBtn":"ToggleBtn_ToggleBtn__25QBa","CheckInput":"ToggleBtn_CheckInput__3Hkyr","Slider":"ToggleBtn_Slider__RtT27"};